module.exports = __webpack_public_path__ + "static/media/ocean_badge.32dc1358.jpg";